import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import axios from 'axios';
import { Lightbulb, Link, Trophy, X, ArrowRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;
const ICONS = { lightbulb: Lightbulb, link: Link, trophy: Trophy };

const SmartNotifications = () => {
  const { token } = useAuth();
  const { lang } = useLanguage();
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    axios.get(`${API}/smart-notifications/generate`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setNotifications(r.data.notifications || [])).catch(console.error);
  }, [token]);

  const dismiss = async (id) => {
    setNotifications(prev => (Array.isArray(prev) ? prev : []).filter(n => n.id !== id));
    try { await axios.post(`${API}/smart-notifications/dismiss/${id}`, {}, { headers: { Authorization: `Bearer ${token}` } }); } catch (e) {}
  };

  if (notifications.length === 0) return null;

  return (
    <div className="smart-notif-container" data-testid="smart-notifications">
      {(Array.isArray(notifications) ? notifications : []).map(n => {
        const Icon = ICONS[n.icon] || Lightbulb;
        const typeColors = { suggestion: '#3b82f6', workflow: '#8b5cf6', milestone: '#10b981' };
        return (
          <div key={n.id} className="smart-notif-item" style={{ borderLeftColor: typeColors[n.type] || '#3b82f6' }} data-testid={`notif-${n.id}`}>
            <Icon size={16} style={{ color: typeColors[n.type], flexShrink: 0 }} />
            <span className="body-small" style={{ flex: 1 }}>{lang === 'nl' ? n.message_nl : n.message_en}</span>
            {n.action_path && <button className="smart-notif-action" onClick={() => navigate(n.action_path)} data-testid={`notif-action-${n.id}`}><ArrowRight size={14} /></button>}
            <button className="smart-notif-dismiss" onClick={() => dismiss(n.id)} data-testid={`notif-dismiss-${n.id}`}><X size={14} /></button>
          </div>
        );
      })}
    </div>
  );
};

export default SmartNotifications;
